import { ForEmployers as ForEmployersView } from './for-employers';
import { ForEmployersProvider } from './for-employers.provider';

export const ForEmployers = () => (
   <ForEmployersProvider>
      <ForEmployersView />
   </ForEmployersProvider>
);

export const FeatureForEmployers = ForEmployers;
